import React from 'react'
import { Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import {loadActiveUsers, loadUsers} from '../../../common/users/actions'

class InstructorOnFilter extends React.Component {
  componentWillMount() {
    const { loadUsers, users } = this.props
    if (!users.size) loadUsers({ sort: 'lastNameSort' })
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const { users, loadUsers, value, onChange, ...remainingProps } = this.props
    const userOptions = users.filter(u => u.role === 'INSTRUCTOR').reduce((options, user) => {
      options.push({ value: user._id, text: user.nameReversed })
      return options
    }, [])
    if (!remainingProps.multiple) userOptions.unshift({ value: '', text: 'Vše' })
    let realValue = value
    if (!realValue && remainingProps.multiple) realValue = []
    return (
      <Form.Select
        options={userOptions}
        value={realValue}
        onChange={(e, value) => onChange(value)}
        {...remainingProps}
      />
    )
  }
}

InstructorOnFilter.defaultProps = {
  multiple: false,
  value: '',
}

InstructorOnFilter.propTypes = {
  loadActiveUsers: React.PropTypes.func.isRequired,
  users: React.PropTypes.object.isRequired,
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  users: state.users.all,
}), { loadUsers })(InstructorOnFilter)



// WEBPACK FOOTER //
// ./src/browser/components/filters/InstructorOnFilter.js